// React
import React from "react";

// MUI
import { Box, FormControl, MenuItem, Select } from "@mui/material";

// Third party imports
import { GB, IT } from "country-flag-icons/react/3x2";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", name: "English", flag: GB },
  { code: "it", name: "Italiano", flag: IT },
];

const LanguageOption = ({ lang, compact = false }) => {
  const FlagIcon = lang.flag;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <FlagIcon
        width={20}
        height={15}
        aria-hidden="true"
        style={{ borderRadius: 2, flexShrink: 0 }}
      />
      <Box component="span" sx={compact ? { display: { xs: "none", md: "inline" } } : undefined}>
        {lang.name}
      </Box>
    </Box>
  );
};

/** Language picker. The name is hidden on small screens in the closed state (the flag stays). */
export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  const resolvedLang = i18n.resolvedLanguage ?? i18n.language;
  const current = languages.find((lang) => lang.code === resolvedLang) || languages[1];

  return (
    <FormControl size="small">
      <Select
        value={current.code}
        onChange={handleChange}
        inputProps={{ "aria-label": current.name }}
        renderValue={() => <LanguageOption lang={current} compact />}
        sx={{ "& .MuiSelect-select": { display: "flex", alignItems: "center" } }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            <LanguageOption lang={lang} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
